import _ from "lodash";

export function updateSearchParams(searchParams:URLSearchParams, setSearchParams:(payload:any) => any, payload:{[key:string]:string}) {
  setSearchParams({ ...(_.fromPairs([...searchParams.entries()])), ...payload });
}